<template>
  <div>
    <header
      class="fixed top-0 left-0 z-50 flex w-full justify-center px-5 pt-5 lg:hidden"
    >
      <div
        :class="[
          'flex h-11 items-center justify-between overflow-hidden rounded-[7px] bg-gray-dark px-3.75 shadow-[0_4px_5px_rgba(0,0,0,0.15)] transition-all duration-500 ease-[cubic-bezier(0.32,0.72,0,1)] will-change-[width]',
          isExpanded ? 'w-full sm:w-83.75' : 'w-12.5',
        ]"
      >
        <NuxtLink
          to="/"
          :class="[
            'overflow-hidden text-sm/[115%] whitespace-nowrap text-white transition-all ease-[cubic-bezier(0.32,0.72,0,1)] will-change-[max-width,opacity]',
            isExpanded
              ? 'max-w-full opacity-100 delay-75 duration-400 sm:max-w-[280px]'
              : 'pointer-events-none max-w-0 opacity-0 duration-200',
          ]"
          @click="isMenuOpen = false"
        >
          <ClientOnly>{{ t('header.title') }}</ClientOnly>
        </NuxtLink>

        <button
          @click="handleNavClick"
          class="flex shrink-0 cursor-pointer items-center justify-center text-white"
          :aria-label="t('common.open.menu')"
        >
          <HamburgerIcon class="h-5 w-5" />
        </button>
      </div>
    </header>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const { t } = useI18n()

const emit = defineEmits<{
  'open-navigation': []
  'open-search': []
}>()

const isMenuOpen = ref(false)
const isScrolled = ref(false)

const isHomePage = computed(() => {
  return (
    Boolean(route.meta.isHome) ||
    route.name === 'index' ||
    String(route.name || '').startsWith('index')
  )
})

const isExpanded = computed(() => !isHomePage.value || isScrolled.value)

const handleScroll = () => {
  isScrolled.value = window.scrollY > 150
}

onMounted(() => {
  if (import.meta.client) {
    window.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()
  }
})

onUnmounted(() => {
  if (import.meta.client) {
    window.removeEventListener('scroll', handleScroll)
  }
})

const handleNavClick = () => {
  isMenuOpen.value = false
  emit('open-navigation')
}
</script>

<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
